import { createEmailNotification } from "../services/waitlist.service";
import "../../styles/web-components/waitlist-form.scss";
class WaitlistForm extends HTMLElement {
    constructor() {
        super();
        this.formSubmit = this.onSubmit.bind(this);
    }
    formEl;
    formSubmit;
    getFormEl() {
        return this.querySelector('form');
    }
    connectedCallback() {
        this.title = this.getAttribute('title') || `Your selected size & fit is currently unavailable. <br /> We'll notify you once it's back in stock`;
        this.render();
        this.getFormEl().addEventListener('submit', this.formSubmit);
    }
    disconnectedCallback() {
        this.getFormEl().removeEventListener('submit', this.formSubmit);
    }
    async onSubmit(e) {
        e.preventDefault();
        const emailEl = this.querySelector('#waitlist-form-email');
        const email = emailEl?.value;
        const checkboxEl = this.querySelector('#waitlist-form-marketing-consent');
        const optionalArguments = {
            accepts_marketing: checkboxEl?.checked || false,
        };
        if (email) {
            await createEmailNotification(email, +this.getAttribute('variantId'), +this.getAttribute('productId'), optionalArguments).then(() => {
                this.getFormEl().style.display = 'none';
                this.updateStatus('success');
            }).catch((errors) => {
                let msg = "There was an error processing your request. Please try again later.";
                // only certain errors are end-user friendly
                const userFriendlyError = errors?.base || errors?.email;
                if (userFriendlyError) {
                    msg = userFriendlyError;
                }
                this.updateStatus('error', msg);
            });
        }
    }
    updateStatus(status, msg) {
        const statusEl = this.querySelector('.waitlist-form__status');
        statusEl.dataset.status = status;
        if (status === 'success') {
            statusEl.textContent = "Thank you! We’ll notify you as soon as this item is available.";
        }
        else if (status === 'error') {
            statusEl.textContent = msg;
        }
        else {
            statusEl.textContent = '';
        }
    }
    render() {
        this.innerHTML = `
    <div class="waitlist-form__container">
      <p class="waitlist-form__title">${this.title}</p>
      <form class="waitlist-form__form">
        <div class="waitlist-form__email-container">
          <label class="waitlist-form__label" for="waitlist-form-email">* Email Address</label>
          <input class="waitlist-form__email-input" type="email" id="waitlist-form-email" required/>
        </div>
        <div class="waitlist-form__consent-container">
          <input class="waitlist-form__checkbox" type="checkbox" id="waitlist-form-marketing-consent" checked>
          <label class="waitlist-form__marketing-label" for="waitlist-form-marketing-consent">
              Keep me updated on exclusive news and offers from UNTUCKit
          </label>
        </div>
        <button class="button-v2 primary waitlist-form__submit" type="submit">Notify Me</button>
      </form>
      <p class="waitlist-form__status"></p>
    </div>
  `;
    }
}
if (!window.customElements.get("waitlist-form")) {
    customElements.define("waitlist-form", WaitlistForm);
}
